module.exports = "<div class=\"gw-row-layout\" gw-partial=\"Item\"></div>\n"